import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const PrescriptionView = ({ prescriptions }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { clinicStocks } = useSelector((state) => state?.clinic);

  const renderData = (li, currPrd) => {
    return (
      <div className="gray-back-con" key={`rec_${li?.id ?? li?.i}`}>
        <div className="flex-row flex-row-wrap">
          <div className="w85Per">
            <div className="flex-row flex-row-wrap">
              <div className="font-bold fs12 black">
                {li?.name ?? li?.plName}
              </div>
              <div className="flex-row flex-center ml10">
                <div className="gray-dot" />
                <div className="font-medium fs12 black4 ml5">Quantity:</div>
                <div className="txt-regular fs12 black4 ml3">
                  {li?.quantity ?? li?.qty ?? "1"}{" "}
                  {li?.subUnit === "Unit" || li?.unitType === "Unit"
                    ? currPrd?.measurementUnit
                    : currPrd?.subMeasurementUnit}
                </div>
              </div>
              <div className="flex-row flex-center ml10">
                <div className="gray-dot" />
                <div className="font-medium fs12 black4 ml5">Dosage:</div>
                <div className="txt-regular fs12 black4 ml3">{li?.dosage}</div>
              </div>
              <div className="flex-row flex-center ml10">
                <div className="gray-dot" />
                <div className="font-medium fs12 black4 ml5">Duration:</div>
                <div className="txt-regular fs12 black4 ml3">
                  {li?.duration ?? "1"} days
                </div>
              </div>
              {li?.meal?.length > 0 ? (
                <div className="flex-row flex-center ml10">
                  <div className="gray-dot" />
                  <div className="txt-regular fs12 black4 ml5">
                    {li?.meal === "afterMeal"
                      ? "After Meal"
                      : li?.meal === "beforeMeal"
                      ? "Before Meal"
                      : ""}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {(typeof li?.frequency === "string" && li?.frequency?.length > 0) ||
          li?.frequency?.includes("morning") ||
          li?.frequency?.includes("afternoon") ||
          li?.frequency?.includes("night") ? (
            <div className="flex-center">
              <div className="blue-back-con fs12 font-medium">
                {typeof li?.frequency === "string"
                  ? li?.frequency
                  : `${li?.frequency?.includes("morning") ? "1" : "0"}-${
                      li?.frequency?.includes("afternoon") ? "1" : "0"
                    }-${li?.frequency?.includes("night") ? "1" : "0"}`}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  return (prescriptions ?? reqDet?.prescription)?.map((pres, i) => {
    return (
      <div className="mt10" key={`mainLi_${i}`}>
        {pres?.prescriptionDetails?.map((li) => {
          const currPrd = clinicStocks?.data?.find(
            (dta) => dta?.stockId === li?.stockId
          );
          return renderData(li, currPrd);
        })}
        <Typography className="fs12 txt-regular black mt10">
          {pres?.remarks}
        </Typography>
      </div>
    );
  });
};

export default PrescriptionView;
